import React from 'react'

interface LoadingScreenProps {
  message?: string
  subMessage?: string
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = 'Cargando...', 
  subMessage 
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-4">
          <div className="w-full h-full border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
        </div>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
          {message}
        </h2>
        {subMessage && (
          <p className="text-gray-600 dark:text-gray-400 text-sm">
            {subMessage}
          </p>
        )}
      </div>
    </div>
  )
}

export default LoadingScreen 